import { Box, Text, Stack, Group } from "@mantine/core";
import dayjs from "dayjs";

const TIMESTAMP_WITH_OFFSET =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[+-]\d{2}:\d{2}$/;

const formatValue = (value) =>
  TIMESTAMP_WITH_OFFSET.test(value)
    ? dayjs(value).format("YYYY-MM-DD HH:mm:ss")
    : String(value);

function ChangeField({ field, change }) {
  const hasFrom = change.from !== null && change.from !== undefined;
  const hasTo = change.to !== null && change.to !== undefined;

  return (
    <Group gap="xs" wrap="nowrap" align="flex-start">
      <Text size="sm" c="dimmed" style={{ minWidth: 120 }} fw={500}>
        {field}:
      </Text>
      <Group gap={6} wrap="nowrap">
        {hasFrom && (
          <Text
            size="sm"
            c="red"
            style={{ textDecoration: "line-through", opacity: 0.7 }}
          >
            {formatValue(change.from)}
          </Text>
        )}
        {hasFrom && hasTo && (
          <Text size="sm" c="dimmed">
            →
          </Text>
        )}
        {hasTo && (
          <Text size="sm" c="green" fw={500}>
            {formatValue(change.to)}
          </Text>
        )}
      </Group>
    </Group>
  );
}

export function ChangesList({ changes }) {
  if (!changes || Object.keys(changes).length === 0) {
    return (
      <Text size="sm" c="dimmed">
        No changes recorded
      </Text>
    );
  }

  return (
    <Stack gap="sm">
      {Object.entries(changes).map(([field, change]) => {
        const isNestedChange =
          typeof change === "object" && !change.from && !change.to;

        if (isNestedChange) {
          return (
            <Box key={field}>
              <Text size="sm" fw={600} mb="xs">
                {field}:
              </Text>
              <Stack gap="xs" ml="md">
                {Object.entries(change).map(([nestedField, nestedChange]) => (
                  <ChangeField
                    key={nestedField}
                    field={nestedField}
                    change={nestedChange}
                  />
                ))}
              </Stack>
            </Box>
          );
        }

        return <ChangeField key={field} field={field} change={change} />;
      })}
    </Stack>
  );
}
